import styled from 'styled-components';
import { color, fontSize } from 'theme';
import { OVERLAY_CONFIG } from 'styles/overlayConfig';

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${OVERLAY_CONFIG.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  pointer-events: ${(props) => (props.$show ? 'auto' : 'none')};
  transition: opacity ${OVERLAY_CONFIG.fadeInDuration}
    ${OVERLAY_CONFIG.fadeInEasing};
`;

export const OnboardingContent = styled.div`
  max-width: 500px;
  text-align: center;
  padding: 40px;
  background: ${color.darkGray};
  border: 2px solid ${(props) => props.$borderColor || color.red};
  border-radius: 8px;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transition: opacity ${OVERLAY_CONFIG.fadeInDuration}
    ${OVERLAY_CONFIG.fadeInEasing};
`;

export const OnboardingTitle = styled.h1`
  color: ${color.lightGrey};
  font-size: ${fontSize.xlarge};
  margin-bottom: 24px;
  font-weight: 700;
`;

export const OnboardingText = styled.p`
  color: ${color.white};
  font-size: ${fontSize.medium};
  line-height: 1.6;
  margin-bottom: 16px;
  opacity: 0.9;
`;

export const OnboardingButton = styled.button`
  background: ${(props) => props.$bgColor || color.red};
  color: ${color.white};
  border: none;
  border-radius: 4px;
  padding: 14px 32px;
  font-size: ${fontSize.medium};
  font-weight: 600;
  cursor: pointer;
  margin-top: 24px;
  width: 100%;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
